<template>
  <custom-nuxt-link v-if="banner && canDisplayAreaBannerByUser" :class="{ prText: banner.is_show_pr_text }" :to="banner.link" class="banner-wrapper">
    <img
      v-if="isFixedDimension"
      :src="banner.image_url"
      :width="banner.image_width"
      :height="banner.image_height"
      :alt="banner.name"
      class="fixedDimension"
    />
    <img v-else :src="banner.image_url" :alt="banner.name" />
  </custom-nuxt-link>
</template>
<script>
import { canDisplayAreaBanner } from '@/utils/BannerForUser'

export default {
  props: {
    banner: { type: Object, default: null, required: true },
    isFixedDimension: { type: Boolean, default: false, required: false }
  },
  computed: {
    canDisplayAreaBannerByUser() {
      return canDisplayAreaBanner(this.$route, this.$store)
    }
  }
}
</script>

<style lang="scss" scoped>
.prText {
  position: relative;
  overflow: hidden;
  display: block;
  img {
    @include sp {
      margin-bottom: -6px;
    }
  }
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    padding: 0 1rem;
    background-color: $gray-02;
    color: $gray-fa;
    content: 'PR';
    z-index: 1;
  }
}

.fixedDimension {
  width: 100%;
  height: auto;
}

.banner-wrapper {
  border-radius: 1.2rem;
  border: 1px solid $gray-c6;
  display: block;
  overflow: hidden;
  img {
    display: block;
  }
}
</style>
